// @ts-strict-ignore
import { DateMode, DateRangeBlock, FieldBlock } from '@coast/schemas';
import { useMemo } from 'react';
import { MBFieldBlock } from '@shared/components/blocks/lib/field';
import { formatDateRange, formatDateTimeRange, formatTimeRange } from '@shared/util/date';

interface Props {
  startDate: string;
  endDate: string;
  block: DateRangeBlock;
  onPress?(): void;
}

type FormatFunction = (startDate: string, endDate: string) => string;
const formatFunctionByMode: Record<DateMode, FormatFunction> = {
  time: formatTimeRange,
  date: formatDateRange,
  datetime: formatDateTimeRange,
};

export function MBDateRangeBlock({ startDate, endDate, block, onPress }: Props) {
  const mode = block.mode ?? 'date';
  const content = formatFunctionByMode[mode](startDate, endDate);
  const fieldBlock = useMemo((): FieldBlock => ({ ...block, name: null, type: 'field' }), [block]);
  return <MBFieldBlock value={content} block={fieldBlock} onPress={onPress} />;
}
